var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-panel",style:({ height: _vm.height ? `${_vm.height}px` : 'auto' })},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }